// Agents page as specified in appmark.txt
import React from "react";
import { CircuitBoardIcon } from "lucide-react";

export const Agents: React.FC = () => {
  return (
    <div className="space-y-6" data-testid="agents-page">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          Agent Management
        </h1>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <div className="text-center py-12">
          <CircuitBoardIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
            Agent Management
          </h3>
          <p className="text-gray-500 dark:text-gray-400">
            Agent management features will be implemented here.
          </p>
        </div>
      </div>
    </div>
  );
};
